import { uuidv7 } from 'uuidv7';

export const uuid = () => uuidv7();
